import React from 'react'

import TourV1ItemCard from './TourV1ItemCard'
import TourV2ItemCard from './TourV2ItemCard'

import { isTourV1Offer, isTourV2Offer } from 'lib/offerTypes'
import TripSummaryCardLoadingSkeleton from 'tripPlanner/components/TripSummary/TripSummaryCardLoadingSkeleton'
import { useOffer } from 'tripPlanner/hooks/api'
import { TourItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TourItem
}

export default function LETourItemCard({ item }: Props) {
  const { data: offer, isLoading } = useOffer(item.code)

  if (isLoading) return <TripSummaryCardLoadingSkeleton />

  if (!offer) {
    return null
  } else if (isTourV1Offer(offer)) {
    return <TourV1ItemCard item={item} offer={offer} />
  } else if (isTourV2Offer(offer)) {
    return <TourV2ItemCard item={item} offer={offer} />
  }

  return null
}
